// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"815":"23471557","956":"6733cccd"}[chunkId] + ".chunk.js";
};